import React from "react";
import "./Project.css";
import ProjectDiv from "./ProjectDiv";
import { Projects } from "../../data/ProjectData.js";

function Project() {
  return (
    <div className="components" id="projects-grid">
      {Projects.map((project) => (
        <ProjectDiv
          key={project.heading}
          heading={project.heading}
          description={project.description}
          imageName={project.imageName}
          demoUrl={project.demoUrl}
          gitUrl={project.gitUrl}
        />
      ))}

      <div className="project-divs">
        <h2 className="project-div-headers">See more on GitHub</h2>
        <a
          href="https://github.com/ishaan-11"
          rel="noopener noreferrer"
          target="_blank"
        >
          <img
            src={require("../../media/github-icon.svg").default}
            alt=""
            className="icons"
            id="project-github-icon"
          />
        </a>
      </div>
    </div>
  );
}

export default Project;
